(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /*
     * For CF7. Handles the logic of the multiple choice form.
     */

    (function () {
        const choiceForms = document.querySelectorAll('.multichoice-form');
        if (!choiceForms.length) {
            return;
        }

        choiceForms.forEach((choiceForm) => {
            const targetSelect = choiceForm.querySelector('.multichoice');
            const choiceFieldsets = choiceForm.querySelectorAll(
                '.multichoice-form_group'
            );
            const finalMsg = choiceForm.querySelector('#multichoice-form_message');
            const inactive = choiceForm.querySelector('#multichoice-form_inactive');

            let selection;

            if (!(targetSelect || choiceFieldsets || finalMsg || inactive)) {
                return;
            }

            // remove notice that js is required, since we've made it this far
            choiceForm.querySelector('.multichoice-form_no-js').remove();

            // when the user makes a selection...
            targetSelect.addEventListener('change', function handleChange(event) {
                // if for some reason they reset it...
                if (targetSelect.selectedIndex === 0) {
                    for (let fieldset of choiceFieldsets) {
                        if (!fieldset.classList.contains('hidden-fieldset')) {
                            fieldset.classList.add('hidden-fieldset');
                        }
                    }
                    if (!finalMsg.classList.contains('hidden-fieldset')) {
                        finalMsg.classList.add('hidden-fieldset');
                    }
                    if (inactive.classList.contains('hidden-fieldset')) {
                        inactive.classList.remove('hidden-fieldset');
                    }
                    return;
                }

                // get the matching fieldset
                selection = choiceForm.querySelector(
                    '#multichoice-form_option' + targetSelect.selectedIndex
                );

                // if the fieldset is hidden, show it and hide the others
                // and show the message field
                if (selection.classList.contains('hidden-fieldset')) {
                    // first, get them all (back) into hiding
                    // this also hides the inactive button's fieldset (as long as it uses the class!)
                    for (let fieldset of choiceFieldsets) {
                        if (!fieldset.classList.contains('hidden-fieldset')) {
                            fieldset.classList.add('hidden-fieldset');
                        }
                    }

                    // then un-hide the selection & the message box
                    selection.classList.remove('hidden-fieldset');
                    finalMsg.classList.remove('hidden-fieldset');
                }
            });
        });
    })();

    /*
    EXAMPLE:

    [contact-form-7 id="c547585" title="Contact - General Inquiry" html_name="main_contact" html_class="multichoice-form"]

    <fieldset>
    ...
    <label for="interest">What best describes your interest? <span class="req">*<span></label>
    [select* interest id:interest class:multichoice include_blank "opt 1" "opt 2" "opt 3"]
    <p class="multichoice-form_no-js">Please enable JavaScript to interact with this form.</p>
    </fieldset>

    <fieldset id="multichoice-form_option1" class="multichoice-form_group hidden-fieldset">
    ...
    </fieldset>

    <fieldset id="multichoice-form_option2" class="multichoice-form_group hidden-fieldset">
    ...
    </fieldset>

    <fieldset id=multichoice-form_option3" class="multichoice-form_group hidden-fieldset">
    ...
    </fieldset>

    <fieldset id="multichoice-form_message" class="multichoice-form_group hidden-fieldset">
    <label for="message">.....<span class="req">*</span></label> [textarea* message x5 id:message]</div>
    [hidden duration ""]
    <div class="hp"><input type="text" name="email2" value=""></div>
    <p class="submit">[submit "Submit"]</p>
    </fieldset>

    <fieldset id="multichoice-form_inactive" class="multichoice-form_group">
    <p class="submit inactive"><span class="cta-btn--inactive">Submit</span></p>
    </fieldset>

    <p class="legal__footnote">........</p>
    */

}));
